import { GalleryConfig } from 'rangeConfig/@types';

const brorGalleryConfig: GalleryConfig = {
  default: [
    {
      sprs: [
        { id: 'SPR-09471741' },
        { id: 'SPR-59471753' },
        { id: 'SPR-09272652' },
        { id: 'SPR-39272641' },
        { id: 'SPR-89471756' },
        { id: 'SPR-99495097' },
        { id: 'SPR-09471977' },
        { id: 'SPR-79436909' },
        { id: 'SPR-19571858' },
        { id: 'SPR-79571855' },
        { id: 'SPR-99571864' }
      ]
    }
  ]
};

export default brorGalleryConfig;
